import styled from 'styled-components'
import Delete from '../../images/delete.svg'
import SuccessIcon from '../../images/successface.svg'
import Select from 'react-select'


export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -50px;
  padding-top: 30px;
`

export const Bg = styled.div`
  min-height: 100vh;
  height: 100vh;
  width: 100%;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: white;
`

export const MainContainer = styled.div`
  margin:auto;
  position:relative;
  width: 52%;
  padding-top:1rem;

  @media (max-width: 1200px) {
    width: 72%;
  }

  @media (max-width: 800px) {
    width: 92%;
  }
`

export const FormContainer = styled.div`
  margin:auto;
  position:relative;
  margin-top:3rem;
  width:100%;
`

export const BoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  margin-top:0.3rem;
`

export const Name = styled.div`
font-family:Poppins;
font-weight:300;
font-size:0.8rem;
font-style:normal;
margin-left: 1rem;
color:#4F4F4F;
`

export const ButtonContainer = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
`
export const Button = styled.button`
  width: 16.3rem;
  height: 3rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  font-style:normal;
  text-align: center;
  color:#868383;
  margin-top: 0.5rem;
  border-radius: 10px;
  background-color:#EFF0F6;
  border: unset;
`
export const DeleteButton = styled.button`
  width: 8.8rem;
  height: 3rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  font-style:normal;
  text-align: center;
  color:#868383;
  margin-top: 0.5rem;
  padding-left: 5%;
  cursor: pointer;
  border-radius: 10px;
  background-color:#EFF0F6;
  background-image: url(${Delete});
  background-repeat: no-repeat;
  border: unset;
  background-position: bottom 50% left 12%;
`

export const FeedBack = styled.div`
  color: red;
  margin-left: 1rem;
  margin-top:-0.7rem;
  font-family: Poppins;
  font-weight: 400;
  font-size: 0.7rem;
`
export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 5rem;
`

export const Success = styled.div`
  position: absolute;
  z-index: 10;
  top: 12rem;
  left: 25rem;
  height: 9rem;
  width: 15rem;
  border-radius: 0.5rem;
  text-align: center;
  background-color: #FFFCD3;
  font-family: Poppins;
`

export const TextSuccess = styled.div`
  margin-top: 1.5rem;
  font-size: 1.1rem;
`
export const ImgSuccess = styled.img`
  margin-top: 1rem;
  height: 4rem;
  src: url(${SuccessIcon});
`


export const TrainingChoices = styled.div`
  border:1px solid #979797;
  border-radius:10px;
  margin:0.5rem 0;
  padding: 0.5rem;
`
export const TrainingChoice = styled.div`
  margin:0.3rem;
`
export const TrainingInput = styled.input`
`

export const TrainingLabel = styled.label`
  font-family: Poppins;
  font-size: 15px;
  margin:0.5rem;
  margin-left: 10px;
  padding-bot: 11rem;
  cursor:  pointer;
  vertical-align: top;
`

export const LicenceSelector = styled(Select)`
.react-select__control {
  border-radius: 10px;
  width: 100%;
  color:black;
  font-family:Poppins;
  font-size:13px;
  outline: none;
  border: 1px solid #B3ABBC;
  height: 2.75rem;
  cursor: pointer;
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor:  pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  color: black;
}
  & .react-select__control--is-focused {box-shadow: 0px 0px 3px 3px #00C4F3;}
`

export const SelectorLicenceContainer = styled.div`
  margin-bottom: 1rem;
  margin-top: 0.7rem;
`

/* ── Sessions attribuées section ──────────────────────────────── */

export const SessionsWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`

export const SessionsSectionTitle = styled.h2`
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 300;
  color: #4F4F4F;
  margin: 0 0 0.5rem 1rem;
`

export const SessionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const SessionCard = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 0px 4px 0px rgba(43,123,199,0.25);
  padding: 0.4rem 0.75rem;
  gap: 0.75rem;
  min-height: 4.5rem;
`

export const SessionLogo = styled.div`
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const SessionInfoBlock = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
`

export const SessionCategory = styled.span`
  font-family: Poppins;
  font-size: 0.55rem;
  font-weight: 700;
  color: ${props => props.color || '#6462FC'};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const SessionName = styled.span`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SessionMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  flex-shrink: 0;
`

export const SessionMetaLine = styled.span`
  font-family: Poppins;
  font-size: 0.65rem;
  font-weight: 400;
  color: #4F4F4F;
  white-space: nowrap;
`

export const SessionSpacer = styled.div`flex: 1;`

export const StatusTag = styled.span`
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 1rem;
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
  background: ${props => {
    if (props.status === 'completed') return '#E6F9EE'
    if (props.status === 'started')   return '#EEF5FF'
    return '#FFF7ED'
  }};
  color: ${props => {
    if (props.status === 'completed') return '#00C52B'
    if (props.status === 'started')   return '#3494FA'
    return '#F59E0B'
  }};
`

export const RetireBtn = styled.button`
  height: 1.8rem;
  padding: 0 0.75rem;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 0.7rem;
  font-weight: 600;
  color: #EF4444;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover { background: #FEE2E2; }
`

export const SessionEmptyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.4rem;
  font-family: Poppins;
  font-size: 0.8rem;
  color: #BABABA;
  border: 1px dashed #E0E0E0;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  &:hover { border-color: #00C4F3; color: #00C4F3; }
`
